<template>
  <div v-if="isOpened"
       class="comments"
  >
    <div v-for="c in comments"
         :key="c.id"
    >
      <div>
        <div class="comment-heading">
          {{ user(c.creator.id).username }} {{ c._relative_time }}
          <span v-if="LEVEL_LIMIT >= level"
                :id="`comment-${c.id}`"
                class="reply"
                :style="{'background-color': highlightCommentId === c.id ? 'yellow' : 'transparent'}"
                @click="startReply(c)"
          >
            <i class="fas fa-reply"></i>
            odpovědět
          </span>
        </div>
        <span class="comment-body"
              v-html="c.text"
        >
        </span>
      </div>
      <CommentsList
        v-if="LEVEL_LIMIT > level"
        :style="{'margin-left': `${level + 1 * 30}px`, 'margin-bottom': `${isOpened ? '10px': '0'}`}"
        :entityId="entityId"
        :entityType="entityType"
        :parentId="c.id"
        :open="c.id === openId"
        :level="level + 1"
      ></CommentsList>
    </div>
    <NewComment :entityId="entityId"
                :entityType="entityType"
                :parentId="parentId"
                :initialText="initialText"
    ></NewComment>
  </div>
  <div v-else-if="commentCount > 0"
       @click="selfOpen = true"
  >
    <span class="show-more">
      Zobrazit <span class="show-more-counter">{{ commentCount }}</span> odpověď/i.
    </span>
  </div>
</template>

<script>
// import { DATE_TIME_FORMAT } from 'CORE/utils/date'
import { size, filter, get, map, orderBy } from 'lodash'
import moment from 'moment'

import NewComment from './new'

export default {
    name: 'CommentsList',
    components: {
        NewComment,
    },
    props: {
        entityId: {
            type: String,
            required: true,
        },
        entityType: {
            type: String,
            required: true,
        },
        parentId: {
            type: String,
            required: false,
            default: _ => null,
        },
        level: {
            type: Number,
            required: false,
            default: _ => 0,
        },
        open: {
            type: Boolean,
            required: false,
            default: _ => false,
        },
    },
    data() {
        return {
            commentText: '',
            openId: null,
            selfOpen: false,
            LEVEL_LIMIT: 1,
            initialText: null,
            highlightCommentId: null,
        }
    },
    computed: {
        isOpened() {
            return this.open || this.selfOpen
        },
        commentCount() {
            return size(this.comments)
        },
        comments() {
            let comments = this.$store.getters.commentsForEntity(this.entityId)
            comments = map(comments, c => {return { ...c, '_relative_time': moment(get(c, 'updatedAt'), 'X').fromNow() }})
            comments = orderBy(comments, ['updatedAt'], ['desc'])
            return filter(comments, c => get(c, 'parent.id', null) === this.parentId)
        },
    },
    methods: {
        user(id) {
            return this.$store.getters.userById(id)
        },
        startReply(comment) {
            this.openId = comment.id
            if (this.level === this.LEVEL_LIMIT) {
                const userName = this.user(comment.creator.id).username
                this.initialText = `<a class="comment-link" href="#comment-${comment.id}" comment="${comment.id}">${userName}</a>`
            }
        },
        onSubmit(e) {
            console.info(e, this.commentText)
        },
    },
}
</script>

<style lang="scss">
  .comment-heading {
    font-size: 75%;
    font-weight: bold;
  }
  .comment-body {
    background-color: rgba(0, 0, 0, 0.05);
    padding: 7px 12px;
    border-radius: 7px;
    display: inline-block;
    margin-bottom: 10px;
  }
  .reply {
      cursor: pointer;
      color: deepskyblue;
      &:hover {
          text-decoration: underline;
      }
  }
  .show-more {
    font-size: 75%;
    font-weight: bold;
    cursor: pointer;
    color: deepskyblue;
    &:hover {
        color: var(--warning);
        cursor: pointer;
    }
  }
  .show-more-counter {
    color: var(--red);
  }
  .comment-link {
    background-color: skyblue;
    font-weight: bold;
    border-radius: 4px;
    padding: 2px;
    color: black;
    text-decoration: none;
    cursor: pointer;
  }
</style>

